import React from 'react';
import { DrawerContextTitle } from 'common/drawer/DrawerContextTitle';
import { IconName, Icon, CopyToClipboard } from '@beeline.com/bp-design-system';
import { useSnackbar } from 'src/utils/hooks/useSnackbar';
import { useCommonIntl } from '../translations/useCommonIntl';
import { LoadingContent } from 'common/LoadingContent';
import { TruncateText } from 'common/Text/TruncateText';

interface Props {
  referenceId: string;
  iconName?: IconName;
  loading?: boolean;
  maxCharactersBeforeTruncation?: number | 'parent';
}

const DrawerID: React.FC<React.PropsWithChildren<Props>> = ({
  referenceId,
  iconName = 'tag',
  loading = false,
  maxCharactersBeforeTruncation = 60
}) => {
  const intl = useCommonIntl();
  const { showSuccess } = useSnackbar();

  return (
    <CopyToClipboard
      tooltipText={intl.copy}
      valueToCopy={referenceId}
      onCopy={() => showSuccess(intl.copiedToClipboard)}
    >
      <DrawerContextTitle dataTest="drawer-title" icon={<Icon name={iconName} color="colorOnSurfaceVariant" />}>
        <LoadingContent loading={loading}>
          <TruncateText maxCharacters={maxCharactersBeforeTruncation}>{referenceId}</TruncateText>
        </LoadingContent>
      </DrawerContextTitle>
    </CopyToClipboard>
  );
};

export default DrawerID;
